import { environment } from '@environments/environment';
import { ClientsSessionService } from '@shared/services/client-session.service';

export class ModuleUrlBuilder {
  constructor(private clientService: ClientsSessionService) {}

  settings = (() => 'mainmenu/module/setting')();

  digitalSignature = (() => 'signingHub')();

  digitalMailbox = (() => 'digitalmailbox/inbox-document/INBOX')();

  consentManagement = (() =>
    'mainmenu/module/consent-management/consent/list')();

  documentManagement = (() => {

    const currentUser = JSON.parse(
      sessionStorage.getItem("currentUser") || null
    ) || {};

    console.log("IN MODULE URL", currentUser);

    return `${
      environment.documentManagementEndpoint
    }/#/auth/authorize?uid=${ currentUser.uid }&ucode=${ currentUser.ucode }`;
  })();


  printAndPost = (() => {    
    return environment.printAndPostEndpoint;
  })();

  helpdesk = (() => {    
    return environment.helpdeskEndpoint;
  })();
  
  publicRelation = (() => {    
    return environment.publicRelationEndpoint;
  })();

  billingSystem = (() => 'mainmenu/module/billing')();
  paymentSystem = (() => 'mainmenu/module/payment')();
  configBillSystem = (() => 'mainmenu/paybill/admin/company-list-all')();
  adminDashboardSystem = (() => 'mainmenu/paybill/admin/services-dashboard')();
  myServiceSystem = (() => 'mainmenu/paybill/user')();
}
